import styles from './styles.module.css';
import InvestorIcon from './icons/InvestorIcon';
import InvestmentIcon from './icons/InvestmentIcon';
import AssetIcon from './icons/AssetIcon';
import ServiceProviderIcon from './icons/ServiceProviderIcon';
import AssetManagment from './icons/AssetManagment';
import CloseIcon from './icons/CloseIcon';
import AddIcon from './icons/AddIcon';
import FundOfFundsIcon from './icons/FundOfFundsIcon';
import CloseRoundedIcon from './icons/CloseRoundedIcon';
import ZoomIcon from './icons/ZoomIcon';
import CheckIcon from './icons/CheckIcon';
import EditIcon from './icons/EditIcon';
import QuestionMarkIcon from './icons/QuestionMarkIcon';
import CheckGroupsIcon from './icons/CheckGroupsIcon';
import ChevronDownFilled from './icons/ChevronDownFilledIcon';
import OtherIcon from './icons/OtherIcon';
import PenIcon from './icons/PenIcon';
import UnicornIcon from './icons/UnicornIcon';
import UploadIcon from './icons/UploadIcon';
import HistoryIcon from './icons/HistoryIcon';
import KnowledgeBaseIcon from './icons/KnowledgeBaseIcon';
import LibraryIcon from './icons/LibraryIcon';
import StorageIcon from './icons/StorageIcon';
import WorkflowsIcon from './icons/WorkflowsIcon';
import CurrentWorkflowIcon from './icons/CurrentWorkflowIcon';
import PlatformIcon from './icons/PlatformIcon';
import MenuCollapseIcon from './icons/MenuCollapseIcon';
import ContactIcon from './icons/ContactIcon';
import ReturnIcon from './icons/ReturnIcon';
import LinkIcon from './icons/LinkIcon';
import FolderLargeIcon from './icons/FolderLargeIcon';
import InfoIcon from './icons/InfoIcon';
import ChevronRightIcon from './icons/ChevronRightIcon';
import PlusIcon from './icons/PlusIcon';
import TaskIcon from './icons/TaskIcon';
import UploadSimpleIcon from './icons/UploadSimpleIcon';
import FileIcon from './icons/FileIcon';
import CheckRoundedIcon from './icons/CheckRoundedIcon';
import ChevronTop from './icons/ChevronDownFilledIcon';
import ChevronToggleIcon from './icons/ChevronToggleIcon';
import UserIcon from './icons/UserIcon';
import DashboardIcon from './icons/DashboardIcon';
import DisclaimerIcon from './icons/DisclaimerIcon';
import LogoutIcon from './icons/LogoutIcon';
import ChatGPTIcon from './icons/ChatGPTIcon';
import ClaudeIcon from './icons/ClaudeIcon';
import GeminiIcon from './icons/GeminiIcon';
import ChevronDown from './icons/ChevronDownIcon';
import PenOutlineIcon from './icons/PenOutlineIcon';
import ForwardIcon from './icons/ForwardIcon';
import FolderIcon from './icons/FolderIcon';
import DeleteIcon from './icons/DeleteIcon';

export enum Icons {
    investor = 'investor',
    investment = 'investment',
    fund = 'fund',
    asset = 'asset',
    serviceProvider = 'serviceProvider',
    assetManagement = 'assetManagement',
    close = 'close',
    closeRounded = 'closeRounded',
    add = 'add',
    fundOfFunds = 'fundOfFunds',
    zoom = 'zoom',
    edit = 'edit',
    check = 'check',
    checkRounded = 'checkRounded',
    questionMark = 'questionMark',
    checksGroup = 'checksGroup',
    chevronDownFilled = 'chevronDownFilled',
    chevronDown = 'chevronDown',
    chevronTop = 'chevronTop',
    chevronToggle = 'chevronToggle',
    other = 'other',
    pen = 'pen',
    unicorn = 'unicorn',
    upload = 'upload',
    history = 'history',
    knowledgeBase = 'knowledgeBase',
    libraryIcon = 'libraryIcon',
    storage = 'storage',
    workflow = 'workflow',
    currentWorkflow = 'currentWorkflow',
    platform = 'platform',
    contact = 'contact',
    menuCollapse = 'menuCollapse',
    return = 'return',
    link = 'link',
    folderLarge = 'folderLarge',
    info = 'info',
    chevronRight = 'chevronRight',
    plus = 'plus',
    task = 'task',
    uploadSimple = 'uploadSimple',
    file = 'file',
    user = 'user',
    dashboard = 'dashboard',
    disclaimer = 'disclaimer',
    logout = 'logout',
    chatGpt = 'chatGpt',
    claudeIcon = 'claudeIcon',
    geminiIcon = 'geminiIcon',
    penOutline = 'penOutline',
    forward = 'forward',
    folder = 'folder',
    delete = 'delete',
}

interface IconProps {
    icon: Icons;
    className?: string;
}

const Icon = ({ icon, className }: IconProps) => {
    const icons = {
        investor: <InvestorIcon />,
        investment: <InvestmentIcon />,
        fund: <InvestmentIcon />,
        asset: <AssetIcon />,
        serviceProvider: <ServiceProviderIcon />,
        assetManagement: <AssetManagment />,
        close: <CloseIcon />,
        closeRounded: <CloseRoundedIcon />,
        add: <AddIcon />,
        fundOfFunds: <FundOfFundsIcon />,
        zoom: <ZoomIcon />,
        edit: <EditIcon />,
        check: <CheckIcon />,
        checkRounded: <CheckRoundedIcon />,
        questionMark: <QuestionMarkIcon />,
        checksGroup: <CheckGroupsIcon />,
        chevronTop: <ChevronTop />,
        chevronDownFilled: <ChevronDownFilled />,
        chevronDown: <ChevronDown />,
        other: <OtherIcon />,
        pen: <PenIcon />,
        unicorn: <UnicornIcon />,
        upload: <UploadIcon />,
        history: <HistoryIcon />,
        knowledgeBase: <KnowledgeBaseIcon />,
        libraryIcon: <LibraryIcon />,
        storage: <StorageIcon />,
        workflow: <WorkflowsIcon />,
        currentWorkflow: <CurrentWorkflowIcon />,
        platform: <PlatformIcon />,
        menuCollapse: <MenuCollapseIcon />,
        contact: <ContactIcon />,
        return: <ReturnIcon />,
        link: <LinkIcon />,
        folderLarge: <FolderLargeIcon />,
        info: <InfoIcon />,
        chevronRight: <ChevronRightIcon />,
        plus: <PlusIcon />,
        task: <TaskIcon />,
        uploadSimple: <UploadSimpleIcon />,
        file: <FileIcon />,
        chevronToggle: <ChevronToggleIcon />,
        user: <UserIcon />,
        dashboard: <DashboardIcon />,
        disclaimer: <DisclaimerIcon />,
        logout: <LogoutIcon />,
        chatGpt: <ChatGPTIcon />,
        claudeIcon: <ClaudeIcon />,
        geminiIcon: <GeminiIcon />,
        penOutline: <PenOutlineIcon />,
        forward: <ForwardIcon />,
        folder: <FolderIcon />,
        delete: <DeleteIcon />,
    };

    return <span className={`${className || ''} ${styles.icon}`}>{icons[icon]}</span>;
};

export default Icon;
